// sagas.js
import { call, put, takeEvery, take, } from 'redux-saga/effects';
import {
  FETCH_TICKETS_COUNTS_REQUEST,
  FETCH_STATISTICS_REPORT_REQUEST,
  FETCH_COMPLETE_REPORT_REQUEST,
  FETCH_REPORT_HFC_REQUEST,
  FETCH_REPORT_GPON_REQUEST,
  FETCH_REPORT_COPPER_REQUEST,

  fetchTicketCountsSuccess,
  fetchStatisticsReportSuccess,
  fetchCompleteReportSuccess,
  fetchReportHfcSuccess,
  fetchReportGponSuccess,
  fetchReportCopperSuccess,

  fetchTicketCountsFailure,
  fetchStatisticsReportFailure,
  fetchCompleteReportFailure,
  fetchReportHfcFailure,
  fetchReportGponFailure,
  fetchReportCopperFailure
} from './actions';
import { api } from '../../api';

function* fetchTicketCountsSaga(action) {
  try {
    const response = yield call(api.getTicketCounts, action.payload);
    yield put(fetchTicketCountsSuccess(response.data));
  } catch (error) {
    yield put(fetchTicketCountsFailure(error.message));
  }
}

function* fetchStasticsReportSaga(action) {
  try {
    // console.log("data StasticsReport Payload--->", action);
    const response = yield call(api.getStasticsReport, action.payload);
    yield put(fetchStatisticsReportSuccess(response.data));
  } catch (error) {
    yield put(fetchStatisticsReportFailure(error.message));
  }
}

function* fetchCompleteReportSaga(action) {
  try {
    const response = yield call(api.getCompleteReport, action.payload);
    yield put(fetchCompleteReportSuccess(response.data));
  } catch (error) {
    yield put(fetchCompleteReportFailure(error.message));
  }
}

function* fetchReportHfcSaga(action) {
  try {
    const response = yield call(api.getReportHrc, action.payload);
    yield put(fetchReportHfcSuccess(response.data));
  } catch (error) {
    yield put(fetchReportHfcFailure(error.message));
  }
}

function* fetchReportGponSaga(action) {
  try {
    const response = yield call(api.getReportGpon, action.payload);
    yield put(fetchReportGponSuccess(response.data));
  } catch (error) {
    yield put(fetchReportGponFailure(error.message));
  }
}

function* fetchReportCopperSaga(action) {
  try {
    const response = yield call(api.getReportCopper, action.payload);
    yield put(fetchReportCopperSuccess(response.data));
  } catch (error) {
    yield put(fetchReportCopperFailure(error.message));
  }
}

export function* watchFetchTicketCountsData() {
  yield takeEvery(FETCH_TICKETS_COUNTS_REQUEST, fetchTicketCountsSaga);
}

export function* watchFetchStasticsReport() {
  yield takeEvery(FETCH_STATISTICS_REPORT_REQUEST, fetchStasticsReportSaga);
}

export function* watchFetchCompleteReport() {
  yield takeEvery(FETCH_COMPLETE_REPORT_REQUEST, fetchCompleteReportSaga);
}

export function* watchFetchReportHfc() {
  yield takeEvery(FETCH_REPORT_HFC_REQUEST, fetchReportHfcSaga);
}

export function* watchFetchReportGpon() {
  yield takeEvery(FETCH_REPORT_GPON_REQUEST, fetchReportGponSaga);
}

export function* watchFetchReportCopper() {
  yield takeEvery(FETCH_REPORT_COPPER_REQUEST, fetchReportCopperSaga);
}
